<div class="bar-stack-chart-container ion-text-center">
  <canvas baseChart #baseStackBarChart [datasets]="chartDatas" [labels]="chartLabels" [options]="chartOptions" [legend]="isShowLegend" [chartType]="chartType" [plugins]="chartPlugins"></canvas>
</div>
